import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment';
import { HttpClient } from '@angular/common/http';
import { Piece } from '../model/typos/piece.model';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root',
})
export class PieceService {

    constructor(
        protected http: HttpClient,
        private config: ConfigService
    ) {}

    getPieces(): Observable<Piece[]> {
        return this
            .http
            .get<Piece[]>(this.config.apiEndpoint + environment.piece_get_collection);
    }
}
